import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataStockist(params) {
	return client.get("api/ecommerce/stockist/data", {
		params: params,
	});
}

function exportStockist(params) {
	return client.get("api/ecommerce/stockist/export", {
		params: params,
	});
}

function getDataStockistBank(params) {
	return client.get("api/ecommerce/stockist/data_stockist_bank", {
		params: params,
	});
}

function saveStockistBank(params) {
	return client.post("api/ecommerce/stockist/save-stockist-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getStockistStock(params) {
	return client.get("api/ecommerce/stockist-stock/data", {
		params: params,
	});
}

function getStockistStockWithId(params) {
	return client.get("api/ecommerce/stockist-stock/data-with-id", {
		params: params,
	});
}

function exportStockistStock(params) {
	return client.get("api/ecommerce/stockist-stock/export", {
		params: params,
	});
}

function getStockistStockLog(params) {
	return client.get("api/ecommerce/stockist-stock/data_stock_log", {
		params: params,
	});
}

function exportStockistStockLog(params) {
	return client.get("api/ecommerce/stockist-stock/export_stock_log", {
		params: params,
	});
}

function createAdjustmentMB (params) {
	return client.post("api/ecommerce/stockist-stock/stock_adjustment_mb", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataStockist,
	exportStockist,
	getDataStockistBank,
	saveStockistBank,
	getStockistStock,
	getStockistStockWithId,
	exportStockistStock,
	getStockistStockLog,
	exportStockistStockLog,
	createAdjustmentMB
}
